module.exports = __webpack_public_path__ + "static/media/EditIcon.671820cf.svg";